import ProductsTab from './ProductsTab';

export default ProductsTab;
